export const TAG_COLORS = {
  green: "#4CAF50",
  blue: "#2196F3",
  teal: "#009688",
  purple: "#9C27B0",
  orange: "#FF9800",
  red: "#F44336",
  grey: "#9E9E9E",
};
